import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import LazyImage from "./LazyImage";
import { useSaved } from "../hooks/useSaved";

export default function ProjectCard({ project, index = 0 }) {
    const { isSaved, toggle } = useSaved();
    const saved = isSaved(project.id);

    return (
        <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: Math.min(index * 0.05, 0.4), ease: [0.22, 1, 0.36, 1] }}
            className="group relative break-inside-avoid"
            data-testid={`project-card-${project.slug}`}
        >
            <Link to={`/projects/${project.slug}`} className="block relative overflow-hidden">
                <div className="overflow-hidden">
                    <div className="transform transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]">
                        <LazyImage src={project.thumbnail_url} alt={project.title} className="w-full" style={{ aspectRatio: "auto" }} />
                    </div>
                </div>

                {/* gradient overlay on hover */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                <div className="absolute inset-x-0 bottom-0 p-6 translate-y-3 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-500">
                    <div className="overline text-gold mb-2">{project.room_type}</div>
                    <h3 className="font-serif text-2xl text-white leading-tight tracking-tight">{project.title}</h3>
                    <div className="mt-2 text-white/70 text-xs tracking-[0.2em] uppercase">{project.company_name}</div>
                </div>
            </Link>

            <button
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    toggle(project);
                }}
                aria-label="Save"
                data-testid={`project-save-btn-${project.slug}`}
                className={`absolute top-3 right-3 z-10 p-2.5 glass rounded-full transition-colors duration-300 ${saved ? "text-gold" : "text-white/80 hover:text-gold"}`}
            >
                <Heart size={16} strokeWidth={1.5} fill={saved ? "currentColor" : "transparent"} />
            </button>
        </motion.div>
    );
}
